import { defineCatalogue, getLocale } from '../../../i18n';
import { integer } from '../../../i18n/format';
import type { CampaignScopeCount } from './api/schemas';

export const localityStripCatalogue = defineCatalogue(
  {
    'count.state.one': '{count} estado',
    'count.state.other': '{count} estados',
    'count.municipality.one': '{count} município',
    'count.municipality.other': '{count} municípios',
    'count.neighborhood.one': '{count} bairro',
    'count.neighborhood.other': '{count} bairros',
  },
  {
    'count.state.one': '{count} state',
    'count.state.other': '{count} states',
    'count.municipality.one': '{count} municipality',
    'count.municipality.other': '{count} municipalities',
    'count.neighborhood.one': '{count} neighbourhood',
    'count.neighborhood.other': '{count} neighbourhoods',
  },
);

export const lsmPlural = localityStripCatalogue.plural;

/** A locality count's label at either reader of `api`'s `ScopeOut` -- the record's own settled
 *  scope (`ScopeRow`) and the creation dialog's candidature preview (`LocalityStrip`) roll up the
 *  same shape and read it the same way. */
export function scopeCountLabel(count: CampaignScopeCount): string {
  const locale = getLocale();
  if (count.level === 'state' || count.level === 'municipality' || count.level === 'neighborhood') {
    return lsmPlural(`count.${count.level}.other`, count.count, {
      count: integer(count.count, locale),
    });
  }
  // `COUNTED_LEVELS` (core) never rolls a scope's counts up to `country`: kept only so a
  // widened enum on the wire fails as a visible label rather than a thrown render.
  return integer(count.count, locale);
}
